<template>
  <a>
    <span class="modal-body-text">Do you want to approve the event?</span><br/>
    <span
      class="modal-body-text">CLIENT will be notified that the event was approved.</span><br/><br/>
  </a>
</template>

<script>
export default {
  name: 'change-submitted-body-modal'
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// ApproveEvent.vue?282f83dd